import { ReactNode } from 'react';

import cx from 'classnames';

import s from './Drawer.module.scss';

interface IProps {
  show: boolean;
  children: ReactNode;
}

export function Drawer({ show, children }: IProps) {
  return (
    <div className={cx(s.root, { [s.show]: show })}>
      <div className={cx(s.drawerOverlay, { [s.show]: show })}>{children}</div>
      <div className={cx(s.overlay, { [s.show]: show })} />
    </div>
  );
}
